<template>
  <div>
    <div class="video-sliders">
      <carousel :items-to-show="1">
        <slide v-for="(video, index) in videos" :key="index">
          <div target="_blank" class="video-slider-item">
            <img v-lazy="video.thumb_url" class="image" />
            <div class="dark-overlay"></div>
            <div class="bottom-buttons center">
              <span class="play-icon" @click="playVideo(video)">
                <img src="/imgs/play.png" />
                <span>{{ __('動画を再生') }}</span>
              </span>
            </div>
            <div class="bottom-buttons"><a href="/videos" class="btn-pink">{{ __('すべての動画') }}</a></div>
          </div>
        </slide>

        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>

    <div v-for="(video, index) in videos" :key="`video_${index}`">
      <span :id="`videoPlay_${video.id}`" data-toggle="modal" :data-target="`#top-video-modal-${video.id}`" class="hidden"></span>
      <div class="modal fade" data-backdrop="static" :id="`top-video-modal-${video.id}`" aria-hidden="true">
        <div class="vertical-alignment-helper">
          <div class="modal-dialog static modal-lg vertical-align-center">
            <div class="modal-content video-modal-content">
              <div class="modal-body p-0">
                <div class="player-container">
                  <video-js :id="`my_video_${video.id}`" class="vjs-default-skin vjs-big-play-centered" controls preload="auto" data-setup='{"fluid": true}'>
                    <source :src="video.video_url" type="application/x-mpegURL">
                  </video-js>
                </div>
              </div>
              <i class="fa fa-close" data-dismiss="modal" @click="resetModal"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
  import 'vue3-carousel/dist/carousel.css';
  import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

  export default {
    components: {
      Carousel,
      Slide,
      Pagination,
      Navigation
    },
    props: ['paramVideos', 'paramUser', 'paramTexts'],
    data() {
      return {
        videos: [],
        videoUrl: undefined,
        user: undefined,
        players: [],
        currentPlayer: undefined,
        texts: []
      }
    },
    mounted() {
      this.texts = JSON.parse(this.paramTexts)
      this.videos = JSON.parse(this.paramVideos);
      if (this.paramUser) this.user = JSON.parse(this.paramUser)

      let self = this
      this.$nextTick(function() {
        self.videos.map(video => {
          self.players.push({
            id: video.id,
            player: videojs(`my_video_${video.id}`)
          })
        })
      })
    },
    methods: {
      __(key) {
        return this.texts[key] ?? '';
      },
      resetModal() {
        let self = this
        setTimeout(function() {
          self.currentPlayer.player.pause()
        }, 200)
      },
      playVideo(video) {
        if (video.targets.length > 0) {
          if (this.user) {
            if (video.targets.includes('female') && this.user.gender != 'female') {
              centerToastr.fire({
                html: this.__('女性だけが見ることができる動画です。'),
                icon: 'info'
              })

              return;
            }
          } else {
            centerToastr.fire({
              html: this.__("会員だけが見ることができる動画です。"),
              icon: 'info',
              showCloseButton: false,
              showDenyButton: false,
              showCancelButton: true,
              showConfirmButton: true,
              confirmButtonText: this.__("ログインへ"),
              cancelButtonText: this.__("キャンセル"),
              confirmButtonColor: "#8F47AD",
              cancelButtonColor: "#BDBDBD",
              timer: undefined
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/login";
              }
            })

            return;
          }
        }
        $('#showLoading').click();
        this.currentPlayer = this.players.filter(item => item.id == video.id)[0]
        let self = this
        setTimeout(function() {
          $(`#videoPlay_${self.currentPlayer.id}`).click();
          $('#hideLoading').click();
          self.currentPlayer.player.play();
        }, 500)
      },
    }
  }
</script>

<style lang="scss">
.carousel__prev--in-active,
.carousel__next--in-active {
  display: none;
}

.carousel__next {
  margin-right: 2rem;
}

.carousel__prev {
  margin-left: 2rem;
}
</style>
